import { render } from "./PatientCreateAppointment.vue?vue&type=template&id=4538eb38&scoped=true&ts=true"
import script from "./PatientCreateAppointment.vue?vue&type=script&lang=ts"
export * from "./PatientCreateAppointment.vue?vue&type=script&lang=ts"

import "./PatientCreateAppointment.vue?vue&type=style&index=0&id=4538eb38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4538eb38"]])

export default __exports__